import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "tab", "panel", "modeInput", "textarea", "scriptInput",
    "promptInput", "wordCountSelect", "generateBtn", "generateBtnText", "generateError"
  ]

  connect() {
    const form = this.element.querySelector("form")
    if (form) {
      form.addEventListener("submit", () => this.copyActiveTextarea())
    }
  }

  switchTab(event) {
    const mode = event.currentTarget.dataset.mode

    this.tabTargets.forEach(tab => {
      if (tab.dataset.mode === mode) {
        tab.classList.remove("border-transparent", "text-gray-500")
        tab.classList.add("border-indigo-500", "text-indigo-600")
      } else {
        tab.classList.remove("border-indigo-500", "text-indigo-600")
        tab.classList.add("border-transparent", "text-gray-500")
      }
    })

    this.panelTargets.forEach(panel => {
      if (panel.dataset.mode === mode) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })

    this.modeInputTarget.value = mode
  }

  async generateStory() {
    const prompt = this.promptInputTarget.value.trim()
    if (!prompt) {
      this.showGenerateError("Please enter a story idea first")
      return
    }

    const wordCount = this.wordCountSelectTarget.value
    const url = this.element.dataset.generateStoryUrl

    this.setGenerating(true)
    this.hideGenerateError()

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ prompt, word_count: wordCount })
      })

      const data = await response.json()

      if (data.success) {
        // Find the generate-mode textarea and populate it
        const generateTextarea = this.textareaTargets.find(ta =>
          ta.closest("[data-mode]")?.dataset.mode === "generate"
        )
        if (generateTextarea) {
          generateTextarea.value = data.story_text
        }
      } else {
        this.showGenerateError(data.error || "Failed to generate story")
      }
    } catch (error) {
      this.showGenerateError("Network error — please try again")
    } finally {
      this.setGenerating(false)
    }
  }

  copyActiveTextarea() {
    const mode = this.modeInputTarget.value
    const activeTextarea = this.textareaTargets.find(ta => {
      return ta.closest("[data-mode]")?.dataset.mode === mode
    })
    if (activeTextarea && this.hasScriptInputTarget) {
      this.scriptInputTarget.value = activeTextarea.value
    }
  }

  // Private helpers

  setGenerating(loading) {
    if (this.hasGenerateBtnTarget) {
      this.generateBtnTarget.disabled = loading
    }
    if (this.hasGenerateBtnTextTarget) {
      this.generateBtnTextTarget.textContent = loading ? "Generating..." : "Generate Story"
    }
  }

  showGenerateError(message) {
    if (this.hasGenerateErrorTarget) {
      this.generateErrorTarget.textContent = message
      this.generateErrorTarget.classList.remove("hidden")
    }
  }

  hideGenerateError() {
    if (this.hasGenerateErrorTarget) {
      this.generateErrorTarget.classList.add("hidden")
    }
  }
}
